module.exports = "/images/deleteCard.svg?355df2b517566ce09f1cead9f2b55766";